export default __webpack_public_path__ + "static/media/coastKlein.4befa6e2.jpg";